import { Any, JsonObject, JsonProperty } from 'json2typescript';
import { CollectionTranslation } from './collection-translation.model';
import { CollectionCardRankType } from '../../enums/collections/collection-card-rank-type.enum';

@JsonObject('CollectionCard')
export class CollectionCard {

  @JsonProperty('card_id', Number)
  cardId: number = 0;

  @JsonProperty('name', String)
  name: string = '';

  @JsonProperty('rank_type', Number)
  rankType: CollectionCardRankType = CollectionCardRankType.None;

  @JsonProperty('image_updated_at', Any)
  imageUpdatedAt: number | null = null;

  @JsonProperty('translations', [CollectionTranslation])
  translations: CollectionTranslation[] = [];
}
